import type { BlobUploadProgress } from '../api/blobUpload';
import { t } from '../i18n';

export function progressPercent(progress: BlobUploadProgress): number {
  if (progress.bytesTotal <= 0) {
    return 100;
  }

  return Math.min(100, Math.max(0, Math.round((progress.bytesCompleted / progress.bytesTotal) * 100)));
}

export function applyUploadProgress(
  statusEl: HTMLElement,
  progressEl: HTMLProgressElement | null,
  progress: BlobUploadProgress,
): void {
  const percent = progressPercent(progress);
  const key = progress.phase === 'encrypting' ? 'files.upload.encrypting' : 'files.upload.uploading';
  statusEl.hidden = false;
  statusEl.textContent = t(key, { percent });
  if (progressEl) {
    progressEl.hidden = false;
    progressEl.max = 100;
    progressEl.value = percent;
  }
}

export function hideUploadProgress(
  statusEl: HTMLElement | null,
  progressEl: HTMLProgressElement | null,
): void {
  if (statusEl) {
    statusEl.hidden = true;
  }
  if (progressEl) {
    progressEl.hidden = true;
  }
}
